module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=UM - United States Minor Outlying Islands.888527ac.svg";